import { Fragment } from "react/jsx-runtime";
import leven from "leven";

import pageTitles from "../utils/pageTitles";
import CLink from "../components/CLink";
import "../styles/404.scss";

function getClosestStrings(input: string, list: string[], threshold = 5) {
    
    return list
        .map(str => ({ str, distance: leven(input, str) }))
        .filter(({ distance }) => distance <= threshold)
        .sort((a, b) => a.distance - b.distance) 
        .map(({ str }) => str);         
}

export default function NotFound() {


    return (
        <div className="NotFound">
            <div className="main404">
                <div className="four">4</div>
                <div className="zero">0</div>
                <div className="four">4</div>
            </div>
            <div className="sub404">
                <p>
                    {`${window.location.pathname} is not found.`}
                </p>
                <p>
                    {
                        (getClosestStrings(window.location.pathname, Object.keys(pageTitles).slice(1), 3).length > 0) ? (
                            <>
                                Did you mean: 
                                {getClosestStrings(window.location.pathname, Object.keys(pageTitles).slice(1), 3).map((suggestion, index) => (
                                    <Fragment key={index}>
                                        {index > 0 && ", "}
                                        <CLink to={suggestion}>{suggestion}</CLink>
                                    </Fragment>
                                ))}
                            </>
                        ) : (
                            <CLink to="/">Go Home?</CLink>
                        )
                    }
                </p>
            </div>
        </div>
    )
}